// extracted by mini-css-extract-plugin
export var aside = "AppShell-module--aside--94edc";
export var header = "AppShell-module--header--d7e50";
export var main = "AppShell-module--main--fe733";
export var root = "AppShell-module--root--10482";
export var section = "AppShell-module--section--e860c";